import InstructionOverviewSubPage from "./instruction-owerview-sub-page";
import InstructionAttachmentsSubPage from "./instruction-attachments-sub-page";

const SubPage = {
  OverView: InstructionOverviewSubPage,
  Attachments: InstructionAttachmentsSubPage,
};

export default SubPage;
